import { atom } from 'jotai';
import { DASH_INFO } from "../../config";

export default  atom({
    loaded: false,
    selected: DASH_INFO.P_PAGE_NO,
    opened: true,
    marked: null,
});